/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCustomerChargebackSummary} from '../api'

 export const useQueryGetCustomerChargebackSummary = createReactQueryHook('getCustomerChargebackSummary', getCustomerChargebackSummary)
